import cn from 'classnames'
import { Link } from 'legacy/lut/components/shared/Link'
import sanitize from 'sanitize-html'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './CommentEditorIcon.module.scss'

interface IProps {
  comment: string
  isTranslationMode: boolean
  onClick: () => void
}

export const CommentEditorIcon = ({ comment, isTranslationMode, onClick }: IProps) => {
  return isTranslationMode ? (
    <div className={styles.root}>
      <Translation text={'jbp-target-comment'} actionsInside />
    </div>
  ) : (
    <Tooltip
      inline
      tipContent={() => (
        <div className={cn(styles.tipContent)}>
          {!comment && <Translation text={'jbp-target-comment'} actionsInside />}
          <div dangerouslySetInnerHTML={{ __html: sanitize(comment || '') }} />
        </div>
      )}
    >
      <Link className={styles.root} onClick={onClick}>
        <i className={cn('kbase kbase-chat', styles.icon__comment_edit)} />
      </Link>
    </Tooltip>
  )
}
